import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios, { API } from "@/lib/apiClient";
import { SignalTrendChart } from "../components/SignalTrendChart";

const TIER_LABEL = { free: "Free", pro: "Fix Manual", truth: "Truth Verifier", agency: "Sovereign Agency" };

export const TeamDashboard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/team/dashboard`).then((res) => setData(res.data)).catch(() => setData({ audits: [] }));
  }, []);

  if (!data) return <div className="flex min-h-[60vh] items-center justify-center"><div className="h-8 w-8 animate-spin rounded-full border-2 border-sovereign border-t-transparent" /></div>;

  const trendsByBrand = {};
  data.audits.forEach((a) => {
    if (a.visibility_score == null) return;
    if (!trendsByBrand[a.brand_name]) trendsByBrand[a.brand_name] = [];
    trendsByBrand[a.brand_name].push(a);
  });
  const brandsWithTrend = Object.entries(trendsByBrand).filter(([, pts]) => pts.length >= 2);

  return (
    <div className="mx-auto max-w-5xl px-6 py-12" data-testid="team-dashboard-page">
      <h1 className="mb-2 font-heading text-3xl font-bold text-white">Team Dashboard</h1>
      <p className="mb-8 text-sm text-slate-500">Read-only view into your Agency's brand audits.</p>

      {brandsWithTrend.length > 0 && (
        <div className="mb-10 grid gap-4 sm:grid-cols-2" data-testid="team-dashboard-trends">
          {brandsWithTrend.map(([brand, points]) => (
            <SignalTrendChart key={brand} brandName={brand} points={points} />
          ))}
        </div>
      )}

      {data.audits.length === 0 && <p className="text-slate-500" data-testid="team-dashboard-empty">No audits yet on this team.</p>}

      <div className="space-y-3">
        {data.audits
          .slice()
          .reverse()
          .map((a) => (
            <Link
              key={a.id}
              to={`/audit/${a.id}`}
              className="flex items-center justify-between rounded-lg border border-surface-border bg-surface-card p-5 transition-colors hover:border-sovereign/40"
              data-testid={`team-dashboard-audit-row-${a.id}`}
            >
              <div>
                <p className="font-heading text-lg font-semibold text-white">{a.brand_name}</p>
                <p className="text-xs uppercase tracking-wide text-slate-500">{a.status} {a.initiated_by && `- initiated by ${a.initiated_by}`}</p>
              </div>
              <div className="flex items-center gap-6">
                <span className="text-sm text-slate-400">{TIER_LABEL[a.paid_tier] || "Free"}</span>
                {a.visibility_score != null && <span className="font-heading text-2xl font-bold text-white">{a.visibility_score}</span>}
              </div>
            </Link>
          ))}
      </div>
    </div>
  );
};
